import { baseApi } from "../api/baseApi";
// Helper function to convert "Jan, 2025" format to DateOnly format "yyyy-MM-dd"
const convertMonthToDateOnly = (monthString) => {
    // Parse "Jan, 2025" format
    const [monthName, year] = monthString.split(", ");
    const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
    };
    const month = monthMap[monthName];
    // Return in yyyy-MM-dd format (DateOnly format)
    return `${year}-${month}-01`;
};
export const companyMonthConfigsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllCompanyMonthConfigs: builder.query({
            query: () => ({
                url: "CompanyMonthConfigs",
            }),
            providesTags: ["CompanyMonthConfigs"],
        }),
        getCompanyMonthConfigs: builder.query({
            query: (companyId) => ({
                url: "CompanyMonthConfigs/by-company",
                params: { companyId },
            }),
            transformResponse: (response) => {
                if (!response)
                    return [];
                return Array.isArray(response) ? response : [response];
            },
            providesTags: (_result, _error, companyId) => [
                { type: "CompanyMonthConfigs", id: companyId },
            ],
        }),
        createCompanyMonthConfig: builder.mutation({
            query: (body) => ({
                url: "CompanyMonthConfigs",
                method: "POST",
                body: {
                    CompanyId: body.companyId,
                    ConfigMonth: convertMonthToDateOnly(body.configMonth),
                    PocReadOnly: body.pocReadOnly,
                },
            }),
            invalidatesTags: (_result, _error, body) => [
                "CompanyMonthConfigs",
                { type: "CompanyMonthConfigs", id: body.companyId },
                "Projects",
                "ProjectCostValues",
            ],
        }),
        updateCompanyMonthConfig: builder.mutation({
            query: (body) => ({
                url: `CompanyMonthConfigs/${body.id}`,
                method: "PUT",
                body: {
                    CompanyId: body.companyId,
                    ConfigMonth: convertMonthToDateOnly(body.configMonth),
                    PocReadOnly: body.pocReadOnly,
                    ThresholdAmount: body.thresholdAmount,
                    MarginPercentage: body.marginPercentage,
                },
            }),
            invalidatesTags: (_result, _error, body) => [
                "CompanyMonthConfigs",
                { type: "CompanyMonthConfigs", id: body.companyId },
                "Projects",
                "ProjectCostValues",
            ],
        }),
        // Bulk process endpoint: triggers backend processing for a specific month
        bulkProcessCompanyMonthConfigs: builder.mutation({
            query: (body) => ({
                url: `Project/bulk-margin-process`,
                method: "POST",
                body: {
                    companyId: body.companyId,
                    month: convertMonthToDateOnly(body.month).substring(0, 7), // Convert to "yyyy-MM" format
                    thresholdAmount: body.thresholdAmount,
                    marginPercentage: body.marginPercentage,
                },
            }),
            invalidatesTags: ["CompanyMonthConfigs", "Projects"],
        }),
        // Check current status of a bulk margin job (used after page refresh / reconnect)
        getBulkMarginProcessStatus: builder.query({
            query: (jobId) => ({
                url: `Project/bulk-margin-process/status/${jobId}`,
            }),
        }),
        // Fetch all active/queued bulk margin jobs (one per company)
        getActiveBulkMarginJobs: builder.query({
            query: () => ({
                url: "Project/bulk-margin-process/active",
            }),
            transformResponse: (response) => (response !== null && response !== void 0 ? response : []).map((j) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                return ({
                    jobId: j.jobId,
                    companyId: j.companyId,
                    status: j.status,
                    totalProjects: (_a = j.totalProjects) !== null && _a !== void 0 ? _a : 0,
                    processedSoFar: (_c = (_b = j.projectsProcessedSoFar) !== null && _b !== void 0 ? _b : j.processedSoFar) !== null && _c !== void 0 ? _c : 0,
                    updated: (_e = (_d = j.projectsUpdated) !== null && _d !== void 0 ? _d : j.updated) !== null && _e !== void 0 ? _e : 0,
                    skipped: (_g = (_f = j.projectsSkipped) !== null && _f !== void 0 ? _f : j.skipped) !== null && _g !== void 0 ? _g : 0,
                    progressPercent: (_h = j.progressPercent) !== null && _h !== void 0 ? _h : 0,
                    errorMessage: (_j = j.errorMessage) !== null && _j !== void 0 ? _j : null,
                });
            }),
        }),
    }),
});
export const { useGetAllCompanyMonthConfigsQuery, useGetCompanyMonthConfigsQuery, useCreateCompanyMonthConfigMutation, useUpdateCompanyMonthConfigMutation, useBulkProcessCompanyMonthConfigsMutation, useLazyGetBulkMarginProcessStatusQuery, useLazyGetActiveBulkMarginJobsQuery, } = companyMonthConfigsApi;
